import { Routes } from '@angular/router';
import { SettingsComponent } from './settings.component';

export const SETTINGS_ROUTES: Routes = [
  {
    path: '',
    component: SettingsComponent,
    children: [
      { path: '', redirectTo: 'general', pathMatch: 'full' },
      {
        path: 'general',
        loadComponent: () =>
          import('./sections/general/general.component').then((m) => m.GeneralComponent),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./sections/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'webhooks',
        loadComponent: () =>
          import('./sections/webhooks/webhooks.component').then((m) => m.WebhooksComponent),
      },
      {
        path: 'message-templates',
        loadComponent: () =>
          import('./sections/message-templates/message-templates.component').then(
            (m) => m.MessageTemplatesComponent
          ),
      },
      {
        path: 'workflows',
        loadComponent: () =>
          import('./sections/workflows/workflows.component').then((m) => m.WorkflowsComponent),
      },
      {
        path: 'conversation-types',
        loadComponent: () =>
          import('./sections/conversation-types/conversation-types.component').then(
            (m) => m.ConversationTypesComponent
          ),
      },
      {
        path: 'theme',
        loadComponent: () =>
          import('./sections/theme/theme.component').then((m) => m.ThemeComponent),
      },
      {
        path: 'api-keys',
        loadComponent: () =>
          import('./sections/api-keys/api-keys.component').then((m) => m.ApiKeysComponent),
      },
      {
        path: 'audit-log',
        loadComponent: () =>
          import('./sections/audit-log/audit-log.component').then((m) => m.AuditLogComponent),
      },
      {
        path: 'sms-settings',
        loadComponent: () =>
          import('./sections/sms-settings/sms-settings.component').then(
            (m) => m.SmsSettingsComponent
          ),
      },
    ],
  },
];
